import CustomDashboard from "./CustomDashboard";

function Home() {
  return <CustomDashboard />;
}

export default Home;